
import { AssessmentResponse } from '@/types/assessment';
import { supabase } from '@/integrations/supabase/client';

interface StudentInfo {
  name: string;
  educationStatus: string;
  selectedCareers?: string[];
}

/**
 * Calls the Supabase edge function to generate a career guidance report using OpenAI
 */
export const generateOpenAIReport = async (
  responses: AssessmentResponse[],
  studentInfo: StudentInfo
): Promise<string> => {
  try {
    console.log('Starting OpenAI report generation for student:', studentInfo.name);
    
    // Validate responses
    if (!responses || responses.length === 0) {
      throw new Error('No assessment responses provided');
    }

    console.log(`Processing ${responses.length} assessment responses`);

    // Call the Supabase edge function
    const { data, error } = await supabase.functions.invoke('generate-career-report', {
      body: {
        responses,
        studentInfo
      }
    });

    if (error) {
      console.error('Supabase function error:', error);
      throw new Error(`Failed to generate report: ${error.message}`);
    }

    if (!data.success) {
      console.error('Edge function returned error:', data.error);
      throw new Error(data.error || 'Unknown error from report generation service');
    }

    const report = data.report;
    
    if (!report || report.trim().length === 0) {
      console.error('Empty report content received');
      throw new Error('Empty report generated');
    }

    console.log('OpenAI report generated successfully, length:', report.length);
    return report;

  } catch (error) {
    console.error('Error in generateOpenAIReport:', error);
    throw error;
  }
};
